import i18next, { InterpolationOptions, InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import locize from 'i18next-locize-backend';
// @ts-ignore

export const options: InitOptions = {
  fallbackLng: 'en',
  load: 'languageOnly',

  // The full list of namespaces is: 'shared', 'line', 'device', 'stop', 'batches', 'iam', 'alarms', 'stats', 'oee', 'units'
  ns: ['fallback', 'shared'],
  // We use fallback as the default unqualified namespace, to avoid the fallback keys to mess up
  // with the actual keys in the other namespaces.
  defaultNS: 'fallback',

  saveMissing: process.env.NODE_ENV === 'development',

  detection: {
    order: ['cookie', 'header', 'querystring'],
    caches: ['cookie'],
    cookieMinutes: 60 * 24 * 365,
  },

  react: {
    // NOTE: We cannot use Suspense in SSR
    useSuspense: false,
  },

  // NOTE: This option is a bit confusing - it delays initialization until next
  // iteration in the event loop if enabled. We render in the same iteration, so
  // we don't wish to delay initialization.
  initImmediate: false,

  backend: {
    apiKey: process.env.NODE_ENV === 'production' ? undefined : process.env.LOCIZE_API_KEY,
    projectId: process.env.LOCIZE_PROJECT_ID,
    version: 'latest',
  },
};

interface Options {
  namespaces: string[];
  ssrLanguage?: string;
}

export const initI18n = (opts?: Options) => {
  const { ssrLanguage = 'en-GB', namespaces = ['shared'] } = opts || {};

  if (i18next.isInitialized) {
    if (process.browser) {
      return i18next;
    }

    if (i18next.language !== ssrLanguage) {
      i18next.changeLanguage(ssrLanguage);
    }

    return i18next;
  }

  i18next.use(locize);

  if (process.browser) {
    i18next.use(new LanguageDetector());
  }

  i18next
    .init({
      ...options,
      ns: namespaces,
      lng: !process.browser ? ssrLanguage : undefined,
      interpolation: {
        escapeValue: false,
        formatSeparator: ',',
        format: (value, format, lng) => {
          if (format === 'uppercase') {
            return value.toUpperCase();
          }

          return value;
        },
      } as InterpolationOptions,
    })
    .then(() => {
      if (!i18next.language) {
        i18next.changeLanguage('en-GB');
      }
    });

  return i18next;
};
